import { createTheme } from '@mui/material';

const headingFont = ['Oswald', 'sans-serif'].join(',');

/**
 * airportliner colours and fonts (mirrored from airportliner_fe/src/theme.js) on the layout
 * tokens of the Lovable prototype: its radius scale (8 px controls, 10 px dialogs, 14 px cards),
 * 36 px controls, near-white background, outlined surfaces.
 */
export const theme = createTheme({
    palette: {
        primary: { main: '#002f87', contrastText: '#ffffff' },
        secondary: { main: '#ffb813', contrastText: '#1a1a1a' },
        success: { main: '#288928' },
        background: { default: '#f6f7fa' },
    },
    shape: { borderRadius: 8 },
    typography: {
        fontFamily: ['Poppins', 'sans-serif'].join(','),
        h4: { fontFamily: headingFont },
        h5: { fontFamily: headingFont, letterSpacing: '0.25px' },
        h6: { fontFamily: headingFont, letterSpacing: '0.5px', fontWeight: 400 },
        button: { fontWeight: 600, letterSpacing: '0.25px' },
    },
    components: {
        MuiPaper: { defaultProps: { variant: 'outlined' } },
        // Prototype radius scale: cards 14 px, dialogs 10 px, controls the 8 px of `shape`.
        MuiCard: { styleOverrides: { root: { borderRadius: 14 } } },
        MuiDialog: { styleOverrides: { paper: { borderRadius: 10 } } },
        // Prototype dialogs sit on a 24 px inset on all four sides.
        MuiDialogTitle: { styleOverrides: { root: { paddingTop: 24 } } },
        MuiDialogActions: { styleOverrides: { root: { padding: '0 24px 24px' } } },
        MuiButton: {
            defaultProps: { disableElevation: true },
            styleOverrides: { root: { textTransform: 'none' } },
        },
        // A small field is 36 px, level with a medium button (prototype control height).
        MuiOutlinedInput: {
            styleOverrides: { sizeSmall: { '& .MuiOutlinedInput-input': { paddingTop: 6.5, paddingBottom: 6.5 } } },
        },
        MuiChip: { defaultProps: { size: 'small' } },
        MuiTableCell: {
            styleOverrides: {
                // Prototype rows: 12 px above and below a body cell, a 36 px header row; size="small" keeps MUI's 6 px.
                body: ({ ownerState }) => (ownerState.size === 'small' ? {} : { paddingTop: 12, paddingBottom: 12 }),
                head: ({ theme }) => ({
                    paddingTop: 10,
                    paddingBottom: 10,
                    lineHeight: '16px',
                    textTransform: 'uppercase',
                    fontSize: 12,
                    letterSpacing: '0.5px',
                    fontWeight: 600,
                    color: theme.palette.text.secondary,
                }),
            },
        },
    },
});
